<script lang="ts">
	/**
	 * Light/dark toggle.
	 *
	 * Extracted rather than inlined because the sidebar renders it at two very
	 * different sizes (a full-width row in rail mode, a bare icon otherwise),
	 * and because the class toggle has to stay in one place — it writes to
	 * `<html>`, which the pre-hydration theme script also reads.
	 */

	import { Button } from 'flowbite-svelte';
	import { colorTheme } from '../Auth';
	import { t } from '../i18n';

	interface Props {
		/** Extra classes for the icon itself (colour, size). */
		iconClass?: string;
		/** Extra classes for the button. */
		class?: string;
	}

	let { iconClass = '', class: className = '' }: Props = $props();

	/** Flip the stored preference and mirror it onto `<html>` immediately. */
	const fnToggleDarkMode = () => {
		$colorTheme = $colorTheme === 'dark' ? 'light' : 'dark';
		window.document.body.parentElement?.classList.toggle('dark', $colorTheme === 'dark');
	};
</script>

<Button
	class="dark:hover:bg-gray-700 {className}"
	color="alternative"
	title={$colorTheme === 'dark' ? $t('Switch to light mode') : $t('Switch to dark mode')}
	onclick={fnToggleDarkMode}
>
	<i class="fa-solid fa-{$colorTheme === 'dark' ? 'sun' : 'moon'} {iconClass}"></i>
</Button>
